import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useData } from "@/context/DataContext";
import { resolveUrl } from "@/lib/api";
import { Reveal } from "@/components/shared/Reveal";

const PARTNER_CTA_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/4ilszb6v_Novemberka%CC%8Asan%202025-16.webp";

export const PartnerCTA = () => {
  const { settings } = useData();
  const benefits = ["Exponering mot en engagerad publik", "Association med svensk endurohistoria", "Skräddarsydda partnerpaket"];

  return (
    <section id="anmalan" data-testid="partner-cta" className="relative py-24 sm:py-32 overflow-hidden grain">
      <div className="absolute inset-0">
        <img src={resolveUrl(settings?.partner_cta_image) || PARTNER_CTA_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#0B0C0E]/85" />
        <div className="absolute inset-0 headlight-glow" />
      </div>
      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500">Bli partner</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-[1.03]">
            {settings?.partner_cta_heading || "Vill ditt företag vara en del av Novemberkåsan 2026?"}
          </h2>
          <p className="mt-5 text-lg text-white/70 max-w-2xl mx-auto">{settings?.partner_cta_body}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2">
            {benefits.map((b) => (
              <span key={b} className="inline-flex items-center gap-2 text-sm text-white/70">
                <Check className="w-4 h-4 text-amber-500" /> {b}
              </span>
            ))}
          </div>
          <Link to="/kontakt" data-testid="bli-partner-btn" className="mt-9 inline-flex rounded-full bg-amber-500 px-8 py-4 text-sm font-bold uppercase tracking-widest text-black hover:bg-amber-400 transition-colors amber-glow">
            Bli partner
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
